module.exports = __webpack_public_path__ + "e901c667b573149ffa8d675c1a2ac2e5.svg";